import React from "react";
import get from "lodash/get";
import DeviceCompatibilityChecker from "components/DeviceCompatibilityChecker/index";

const DEVICE_COMPATIBILITY_CHECKER = ({ data = {}, generic, ...props }) => {
  const compatibleDevices = get(generic, "compatible_devices", []);

  const mobileBrandList = compatibleDevices.map(item => {
    return { label: item.brand, value: item.brand };
  });

  return (
    <DeviceCompatibilityChecker
      {...props}
      {...data}
      isEsim={data?.isEsimChecker}
      compatibleDevices={compatibleDevices}
      mobileBrandList={mobileBrandList}
    />
  );
};

export default DEVICE_COMPATIBILITY_CHECKER;
